<template>
  <div style="z-index: -1" class="absolute hidden md:block bottom-20 left-24 z-10">
    <img src="../../../assets/images/lines.png" alt="lines" />
  </div>
</template>
